import * as Yup from "yup";

const FormQueryValidationSchemaProjection = Yup.object().shape({
  value: Yup.number().required("Não é permitido cadastrar meta vazia"),
});

export default FormQueryValidationSchemaProjection;
